import { atom } from 'jotai'

export const debugModeAtom = atom(false)

export type DebugDialogState = { open: false } | { open: true; data: unknown; title: string }
export const debugDialogAtom = atom<DebugDialogState>({ open: false })

/** Debug terminal drawer collapsed to the small indicator pill. */
export const debugTerminalCollapsedAtom = atom(false)
